import { makeRequestService } from '@vatsim-petersburg/utils';
import { APPLY_BASE_URL } from '@/constants/constants';

export const applyRequestService = makeRequestService(APPLY_BASE_URL);
